exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-page-overlay[data-v-19e65273]{position:fixed;top:0;bottom:0;left:0;right:0;z-index:1100;background-color:rgba(96,96,96,.5);text-align:center}.c-modal[data-v-19e65273]{position:relative;display:inline-block;width:90%;max-width:800px;vertical-align:middle;margin-top:100px}.c-modal [data-v-19e65273]{text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19e65273","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/common/ModalCard.vue
// module id = Mx78
// module chunks = 0